import state from './Shop/states'
import mutations from './Shop/mutations'
import actions from './Shop/actions'
import getters from './Shop/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
